import React from 'react';
import styles from '../TabShared.module.css';

interface EmptyStateRowProps {
    message: React.ReactNode;
    /** When used inside a table, set inTable=true and provide colSpan */
    inTable?: boolean;
    colSpan?: number;
    className?: string;
}

/**
 * Small shared empty-state renderer. Can render as a full-width table row or as a simple block.
 * Styling leans on shared classes to keep a consistent look.
 */
export const EmptyStateRow: React.FC<EmptyStateRowProps> = ({message, inTable, colSpan = 1, className}) => {
    if (inTable) {
        return (
            <tr>
                <td colSpan={colSpan} className={`${styles.cellPadLg} ${styles.cellCenter} ${className ?? ''}`.trim()}>
                    <span className="text-muted">{message}</span>
                </td>
            </tr>
        );
    }
    return (
        <div className={`${styles.cellCenter} ${className ?? ''}`.trim()}>
            <span className="text-muted">{message}</span>
        </div>
    );
};
